import { optionsOffer } from "../values";

export const IsCollaboratorPlan = (id) => {
  const collaboratorPlan = optionsOffer.find((x) => x.id === 4);

  return collaboratorPlan.uuid === id;
};